import { action, computed, observable } from 'mobx';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { WithdrawalApis } from '../../../apis/withdrawals';
import { WithdrawalId } from '../../../../commonv3/types/withdrawals';
import { translateErrorMessage } from '../../../../commonv3/api/protocol';

export class WithdrawalCancelPageState {
    @observable submitState = new SubmitState();
    @observable open = false;

    @action.bound
    async submit(withdrawalId: WithdrawalId) {
        try {
            await this.submitState.operate(async () => {
                await WithdrawalApis.cancel(withdrawalId);
                this.openModal();
            });
        } catch (e) {
            alert('退会申請の取り消しに失敗しました: ' + translateErrorMessage(e));
        }
    }

    @computed
    get submitting() {
        return this.submitState.submitting;
    }

    @action.bound
    openModal() {
        this.open = true;
    }

    @action.bound
    closeModal() {
        this.open = false;
    }

    @computed
    get loading() {
        return GlobalStatesV3.currentUser.withdrawal.loading;
    }
}
